import { CALL_API, Schemas } from '../../common/middleware/api';
import { toast } from 'react-toastify';

export const INDIVIDUAL_CONSULTATION_FORM_RESPONSES_REQUEST = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSES_REQUEST';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSES_SUCCESS = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSES_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSES_FAILURE = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSES_FAILURE';

export const INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_REQUEST = 'INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_REQUEST';
export const INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_SUCCESS = 'INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_SUCCESS';
export const INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_FAILURE = 'INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_FAILURE';

export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_REQUEST = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_REQUEST';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_SUCCESS = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_FAILURE = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_FAILURE';

export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_REQUEST = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_FAILURE = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_REQUEST = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_REQUEST';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_SUCCESS = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_FAILURE = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_FAILURE';

export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_REQUEST = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_REQUEST';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_SUCCESS = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_FAILURE = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_FAILURE';

export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_REQUEST = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_REQUEST';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_SUCCESS = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_SUCCESS';
export const INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_FAILURE = 'INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_FAILURE';

export const loadIndividualConsultationFormResponses = ({ paymentId, ...options }) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_FORM_RESPONSES_REQUEST, INDIVIDUAL_CONSULTATION_FORM_RESPONSES_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_RESPONSES_FAILURE],
		endpoint: 'api/individualConsultationFormResponse',
		request: { paymentId, ...options },
		schema: Schemas.INDIVIDUAL_CONSULTATION_FORM_RESPONSE_ARRAY
	},
	paymentId
});

export const loadIndividualConsultationFormResponsesByChild = ({ childId, ...options }) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_REQUEST, INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_SUCCESS, INDIVIDUAL_CONSULTATION_CHILD_FORM_RESPONSES_FAILURE],
		endpoint: 'api/individualConsultationFormResponse',
		request: { childId, ...options },
		schema: Schemas.INDIVIDUAL_CONSULTATION_FORM_RESPONSE_ARRAY
	},
	childId
});

export const fetchIndividualConsultationFormResponse = (id) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_REQUEST, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_FETCH_FAILURE],
		endpoint: `api/individualConsultationFormResponse/${id}`,
		schema: Schemas.INDIVIDUAL_CONSULTATION_FORM_RESPONSE
	}
});

export const createIndividualConsultationFormResponse = ({ paymentId, formId, date }, onSuccessEvent) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_REQUEST, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_CREATE_FAILURE],
		endpoint: `api/individualConsultationFormResponse`,
		method: 'POST',
		request: { paymentId, formId, date },
		schema: Schemas.INDIVIDUAL_CONSULTATION_FORM_RESPONSE,
		onSuccessEvent
	}
});

export const updateIndividualConsultationFormResponse = (id, data, onSuccessEvent, onErrorEvent) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_REQUEST, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UPDATE_FAILURE],
		endpoint: `api/individualConsultationFormResponse/${id}`,
		method: 'PUT',
		request: data,
		schema: Schemas.INDIVIDUAL_CONSULTATION_FORM_RESPONSE,
		form: 'customForm',
		onSuccessEvent,
		onErrorEvent
	}
});

export const deleteIndividualConsultationFormResponse = (id, onSuccessEvent) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_REQUEST, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_DELETE_FAILURE],
		endpoint: `api/individualConsultationFormResponse/${id}`,
		method: 'DELETE',
		schema: Schemas.INDIVIDUAL_CONSULTATION_FORM_RESPONSE,
		onSuccessEvent
	}
});

export const undoSubmitIndividualConsultationFormResponse = (id, onSuccessEvent, onErrorEvent) => ({
	[CALL_API]: {
		types: [INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_REQUEST, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_RESPONSE_UNDO_SUBMIT_FAILURE],
		endpoint: `api/individualConsultationFormResponse/${id}/undoSubmit`,
		method: 'PUT',
		schema: Schemas.INDIVIDUAL_CONSULTATION_FORM_RESPONSE,
		form: 'customForm',
		onSuccessEvent,
		onErrorEvent
	}
});